<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="35.9832mm" height="27.5166mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 2751.66"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:currentColor}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <path class="fil0" d="M3215.84 72.94c47.52,-47.52 125.28,-47.52 172.81,0.01l138.75 138.75c47.53,47.53 47.53,125.28 0,172.81l-2155.46 2155.46 -138.75 138.75c-47.52,47.52 -125.29,47.52 -172.81,0l-138.76 -138.75c-0.28,-0.28 -0.54,-0.55 -0.81,-0.82l-849.89 -849.89c-47.53,-47.53 -47.53,-125.29 0,-172.81l138.75 -138.75c47.53,-47.53 125.29,-47.53 172.81,0l764.3 764.3 2069.06 -2069.06z"/>
 </g>
</svg>
